import React, {useEffect, useMemo, useState} from 'react';
import Modal from 'react-modal';
import {ModalCloseX, ModalHeader, WholeWrapper,} from './components';
import {useHistory, useLocation} from 'react-router-dom';
import Loader from "../loader/Loader";
import useCalendar from "../../hooks/calendar";
import useDownloadWorkoutAsPDF from "./useDownloadWorkoutAsPDF";
import CustomInputDropdown from "../input/CustomInputDropdown";
import CustomButton from "../button/CustomButton";
import CustomInput from "../input/CustomInput";
import moment from "moment";
import CustomInputFile from "../input/CustomInputFile";
import {
  CernteredContentFlex, Profileimage, ProfileImageContainer, ProfileimageLine
} from "../add-group-modal.jsx/components";
import ICONS from "../../constants/icons";
import {CameraIconPdf, PdfImage, PdfImageFrame} from "../../pages/profile/components";
import {useCoachPersonalInfo} from "../../hooks";
import CustomInputNumber from "../input/CustomInputNumber";

const customStyles = {
  overlay: {
    backgroundColor: '#05000066',
    zIndex: 3333,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: 'hidden auto',
  },
  content: {
    width: '74%',
    maxWidth: '700px',
    minHeight: '500px',
    height: 'fit-content',
    borderRadius: '8px',
    overflow: 'hidden',
    pointerEvents: 'all',
    background: 'white',
    margin: '4rem auto',
    position: 'static',
    padding: 0,
  },
};

const DownloadWorkoutModal = ({
  name,
  closeModal,
  loading,
  alert,
  urlTraineeUid,
  coachProgramUid,
  day,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const {downloadWorkout} = useDownloadWorkoutAsPDF();
  const [orientation, setOrientation] = useState('landscape');
  const [date, setDate] = useState(Date.now());
  const [workoutName, setWorkoutName] = useState(day?.workout?.name);
  const [imageBase64, setImageBase64] = useState(null);
  const [fontSize, setFontSize] = useState(18);
  const [error, setError] =  useState(null);

  const [numberOfBlockPerPage, setNumberOfBlocksPerPage] = useState('4');
  const {
    currentCoach,
  } = useCoachPersonalInfo({ });

  const convertImageUrlToBase64 = (imageUrl) => {
    fetch(imageUrl, {
      method: "GET",
      mode: 'cors',           // Ensures CORS is handled
      cache: 'no-cache',      // Prevents caching issues
      headers: {'Access-Control-Request-Headers': '*', 'Vary': 'Origin',},
    }).then(response => {
      response.arrayBuffer().then(function(buffer) {
        const url = window.URL.createObjectURL(new Blob([buffer]));
        setImageBase64(url)
      });
    })
        .catch(err => {
          console.log(err);
        });
  };


  useEffect(() => {
    if (currentCoach?.pdfImage?.url) {
      convertImageUrlToBase64(currentCoach.pdfImage.url);
    }
  }, [currentCoach?.pdfImage?.url]);

  const { calendars, calendarsLoading } = useCalendar({
    coachProgramUid,
    startDate: day?.programDay,
    calendarUid: day?.uid,
  });

  const WORKOUT = useMemo(() => {
    if (Array.isArray(calendars)) {
      return calendars?.find((x) => x.type === 'WORKOUT');
    }

    return calendars;
  }, [calendars]);

  const handleDownload = () => {
    setError(null);
    setSubmitting(true);
    debugger;
    downloadWorkout(WORKOUT, orientation, numberOfBlockPerPage, imageBase64, moment(date).format("DD/MM/YYYY"), workoutName, fontSize)
        .then(closeModal)
        .catch(e => setError(e.message))
        .finally(() => setSubmitting(false));
  }

  const handleFontSize = (val) => {
    const newNum = Number(val)

    if (newNum < 0) {
      setFontSize(0);
    } else {
      setFontSize(newNum);
    }
  }

  console.log("base64", imageBase64);
  return (
    <>
      <Modal
        onRequestClose={() => {
          closeModal();
          // history.push(`${history?.location?.pathname}${isGroup ? '?group=true' : ''}`);
        }}
        isOpen={!!day}
        style={customStyles}
        contentLabel="Program Request"
        ariaHideApp={false}
      >
        <div>
          {loading || submitting ? (
              <Loader />
          ) : (
            <WholeWrapper>
              <ModalHeader>
                {name ? `${name} - ` : ''}
                {`Day ${day?.programDay}`}
                <ModalCloseX onClick={closeModal}>X</ModalCloseX>
              </ModalHeader>
              <div style={{padding: 20}}>
                <div>The Image is Required to generate the PDF</div>
                <CernteredContentFlex>
                  <div
                      style={{ width: '18.5rem', margin: '3.8rem auto', position: 'relative' }}
                  >
                    <PdfImageFrame>
                      <PdfImage image={imageBase64}>
                        <CustomInputFile
                            inputId={'pdfImage'}
                            accept="image/*"
                            onChange={async (e) => {
                              const file = e.target.files[0]; // This is already a Blob
                              var reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = (ev) => {
                                setImageBase64(ev.target.result);
                              };
                            }}
                        >
                          <CameraIconPdf />
                        </CustomInputFile>
                      </PdfImage>
                    </PdfImageFrame>
                  </div>
                </CernteredContentFlex>
                <div style={{marginTop: 20}}>Workout Name</div>
                <CustomInput
                    id="edit-meeting-address"
                    color="#373333"
                    outlined
                    borderRadius="8px"
                    height="3.2rem"
                    fontSize="1.4rem"
                    value={workoutName}
                    onChange={(val) => setWorkoutName(val)}
                    margin="0"
                    borderColor="rgba(0, 0, 0, 0.07)"
                    style={{
                      maxHeight: '3.2rem',
                      minHeight: '3.2rem',
                    }}
                    errorIcon={false}
                />
                <div style={{marginTop: 20}}>
                  <div>Choose The Date of the PDF</div>
                  <CustomInput
                      errorIcon={false}
                      placeholder="-Start Date-"
                      type="date"
                      outlined
                      height="4.4rem"
                      margin="0 1.2rem 2.4rem 0"
                      onChange={(v) => {setDate(v)}}
                      value={moment(date).format("YYYY-MM-DD")}
                      borderRadius="8px"
                  />
                </div>
                <div>Choose Font size</div>
                <CustomInputNumber
                    value={fontSize}
                    onChange={(val) => handleFontSize(val)}
                    onIncriment={() => setFontSize(prv => prv +1)}
                    onDecrement={() => setFontSize(prv => prv > 0 ? prv -1 : 0)}
                />
              <div style={{marginTop: 20}}>
                <div>Choose Orientation</div>
              <CustomInputDropdown
                  placeholder="Choose Orientation"
                  value={orientation}
                  returnEntire
                  onChange={(v) => {setOrientation(v)}}
                  options={['landscape', 'portrait']}
                  style={{ margin: '0', maxHeight: '4rem' }}
              />
              </div>
              <div style={{marginTop: 20}}>
                <div>Choose Number Of Blocks In A Page</div>
              <CustomInputDropdown
                  placeholder="Choose Number Of Blocks"
                  value={numberOfBlockPerPage}
                  returnEntire
                  onChange={(v) => {setNumberOfBlocksPerPage(v)}}
                  options={['1', '2', '3', '4', '5', '6', '7', '8']}
                  style={{ margin: '0', maxHeight: '4rem' }}
              />
              </div>

              </div>
              <div style={{padding: 20}}>
              <CustomButton
                  disabled={!imageBase64}
                  fontSize="1.4rem" green onClick={handleDownload}>
                Download Workout
              </CustomButton>
              {error && <div style={{color: 'red', marginTop: 20}}>{error}</div>}
              </div>
            </WholeWrapper>)}
        </div>
      </Modal>
    </>
  );
};

export default DownloadWorkoutModal;
